import React, {Component} from 'react';
import AuthService from '../../services/authService';
import {Link} from 'react-router-dom';
import '../Register/register.scss';
import logo from "../../assets/images/happily-ever-after_m365_WHITE.png";

class Login extends Component {

    constructor() {
        super();
        this.Auth = new AuthService();
    }

    componentWillMount() {
        if (AuthService.loggedIn())
            this.props.history.replace('/welcome');
    }

    getFormData(event) {
        event.preventDefault();
        // console.log("event form", event.currentTarget);
        let email = document.getElementById("login-id").value;
        let password = document.getElementById("login-password").value;

        let loginObj = {
            email,
            password,
        };

        // console.log("loginObj", loginObj);
        this.Auth.login(loginObj).then((res) => {
            if (res.status === 417) {
                return this.props.history.replace(`/reset/${res.token}?email=${res.email}`);
            }
            return this.props.history.replace('/welcome');
        })
            .catch(() => {
                let greeting = document.getElementById('page-greeting');
                greeting.innerText = "Sorry, we weren't able to login you in with those credentials";
                greeting.style.color = 'red';
            })

    }


    render() {
        return (
            <div id="login-page">
                <div className="container">
                    <div className="image-container">
                        <img src={logo} alt="Happily Ever After Logo"/>
                    </div>
                    <div id="login-form-container">
                        <div className="title">New here? <Link to="register">Register here</Link></div>
                        <h3 id="page-greeting">Welcome Back</h3>
                        <div id="login-form">
                            <form onSubmit={this.getFormData.bind(this)}>
                                <div className="form__field">
                                    <label>Email Address</label>
                                    <input id="login-id" type="text" name="email"/>
                                </div>
                                <div className="form__field">
                                    <label>Password</label>
                                    <input id="login-password" type="password" name="password"/>
                                </div>

                                <Link to="/forgot-password/">Forgot Password?</Link>
                                <button type="submit" className="yellow-btn">Login</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        )

    }


}

export default Login;
